__turbopack_context__.v({
  "description": "_5QDhoG_description",
  "label": "_5QDhoG_label",
  "labelWrapper": "_5QDhoG_labelWrapper",
});
